import {
  downloadingFileAsIs,
  downloadingfiles,
  downloadingfilesCsv,
  getBlobMethod,
  getMethod,
  getMethod2,
  getMethod3,
  postMethod,
} from "./httpMethods";
// To populate options only
export const getCountries = () => {
  return new Promise((resolve, reject) => {
    getMethod("info/countrylist", "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getRoles = () => {
  return new Promise((resolve, reject) => {
    getMethod("info/roles", "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getLanguages = () => {
  return new Promise((resolve, reject) => {
    getMethod("info/languages", "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// To actually display on the page, some of them is also used to populate options
// School
export const getSchools = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("school", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const enhancedGetSchools = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("school/list", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const enhancedExportSchools = (params) => {
  return new Promise((resolve, reject) => {
    downloadingfilesCsv(`school/list/export${params || ""}`, "Schools.csv")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getSchool = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("school", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Organization
export const getOrganizations = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("organizations", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// User
export const getUsers = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("user", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// User Profile
export const getProfile = () => {
  return new Promise((resolve, reject) => {
    getMethod("user/profile", "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Participant
export const getParticipants = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("participant", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const enhancedGetParticipants = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("participant/list", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Domain and Tag
export const getDomains = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("tag", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//new domain and tags
export const getDomainsAndTags = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("tag/list", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Competition
export const getCompetitions = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("competition", params, signal)
      .then((d) => {
        resolve(d);
      })
      .catch((e) => reject(e));
  });
};
//get a single competition
export const getCompetition = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("competition", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getCompetitionsPartnerPending = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("competition/partners/pending", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getMarkingPreparation = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("marking/preparation/", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getLevelCountries = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("info/levelCountyParticipantsList", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getMoreInfo = (params, body, signal) => {
  console.log(body);
  return new Promise((resolve, reject) => {
    postMethod(`marking/participants/country/${params}`, body, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Competition Task
export const getDifficultyAndPoints = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("competition/difficultyandpoints/list", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Task
export const getTasks = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("tasks", params, signal)
      .then((d) => {
        resolve(d);
      })
      .catch((e) => reject(e));
  });
};

export const enhancedTasks = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("tasks/list", params, signal)
      .then((d) => {
        resolve(d);
      })
      .catch((e) => reject(e));
  });
};

// Difficulty Group
export const getDifficultyGroup = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("taskdifficultygroup", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
// Collection
export const getCollections = (params, signal) => {
  return new Promise((resolve, reject) => {
    console.log(params);
    getMethod("collection", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const enhancedCollections = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("collection/list", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
//marking overview
export const getMarking = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("marking/v2", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
//
export const getCompCountries = (params, id, signal) => {
  return new Promise((resolve, reject) => {
    console.log(`competition/${id}/countries${params}`);
    getMethod2(`competition/${id}/countries${params}`, "", signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
//editRoundmarking
export const getEditRound = (params, signal) => {
  console.log(params);
  return new Promise((resolve, reject) => {
    getMethod3("marking/moderate", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//generate report
export const getReport = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    console.log(signal);
    getMethod3(`competition/${id}/report?mode=csv`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
//generate report modrate results
export const getModerateReport = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod3(`competition/${id}/report`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getTask = (id) => getMethod("task", id);
export const getDifficulties = () => getMethod("difficulty", "");
export const getUser = (id) =>
  getMethod("user", id).then((data) => ({
    id: data.id,
    username: data.username,
    role: data.role,
    permissionOverridden: true,
    email: data.email,
    country: data.country,
    createdBy: data.createdBy,
    lastModifiedBy: data.lastModifiedBy,
    lastLogin: data.lastLogin,
    status: data.status,
    password: data.password,
  }));
export const getTranslatorCollectionTasks = (gradeId, languageId, signal) => {
  const params = `?translation_assignment_grade_id=${gradeId}&language_id=${languageId}`;
  return new Promise((resolve, reject) => {
    getMethod2("translations/translators/collection-tasks", params, signal)
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
};
export const getTranslatorGradeLanguages = (gradeId, signal) => {
  return new Promise((resolve, reject) => {
    getMethod(
      `translations/translators/grades/${gradeId}/languages`,
      "",
      signal
    )
      .then((data) => resolve(Array.isArray(data) ? data : []))
      .catch((error) => reject(error));
  });
};
export const getTranslatorAssignments = (params = "", signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("translations/translators/assignments", params, signal)
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
};
export const getTranslations = () => {
  return new Promise((resolve, reject) => {
    getMethod("task", "").then((data) => {
      if (data.length) {
        let a = Object.getOwnPropertyNames(data[0]).slice();
        let temp = a[3];
        a[3] = a[4];
        a[4] = temp;
        resolve([
          a.filter(
            (b) =>
              ![
                "lastVerified",
                "createdBy",
                "displayOrder",
                "answers",
                "answerStructure",
                "collections",
                "competitions",
                "recommendedDifficulty",
                "tags",
              ].includes(b)
          ),
          data,
        ]);
      } else {
      }
    });
  });
};
//get partcipient report
export const getParticipantsReport = (index, cert, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod(
      `participant/report/by-certificate?index_no=${index}&certificate_no=${cert}`,
      params,
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//get awardStat status
export const getAwardStatStatus = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`marking/competition/groups/award_statics/${id}`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getGroudStats = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`marking/awards/stats/${id}`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//get competition collection
export const getCompCollection = (id, signal) => {
  return new Promise((resolve, reject) => {
    getMethod(
      `collection/difficultyandpoints/overview?competition_id=${id}`,
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//get Cheaters status
export const getCheaters = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/compute/cheaters/${id}`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const downloadCheater = (id, fileName, country) => {
  return new Promise((resolve, reject) => {
    downloadingfiles(
      country.length == 0
        ? `competition/compute/cheaters/${id}?mode=csv`
        : `competition/compute/cheaters/${id}?country=[${country}]&&mode=csv`,
      fileName
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
export const getCountries2 = (params) => {
  return new Promise((resolve, reject) => {
    getMethod("info/countrylist", params)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//get level tasks
export const getLevelTasks = (competitionId, levelId, signal) => {
  console.log(signal);
  return new Promise((resolve, reject) => {
    getMethod(
      `marking/possible_similar_answers/levels_tasks/${competitionId}?level_id=${levelId}`,
      "",
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getCompAnswers = (id, param, signal) => {
  console.log(id);
  return new Promise((resolve, reject) => {
    getMethod2(`competition/answers/${id}`, param, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getSameParticipants = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/cheaters/same-participant/${id}`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getConfirmedCountries = (id) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/cheaters/confirmed-countries/${id}`, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
//get task possible answers
export const getTaskPossibleAnswers = (taskId, levelId, signal) => {
  return new Promise((resolve, reject) => {
    getMethod(
      `marking/possible_similar_answers/${taskId}?level_id=${levelId}`,
      "",
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//get answer participants
export const getAnswerParticipants = (answerId, signal) => {
  return new Promise((resolve, reject) => {
    getMethod(
      `marking/possible_similar_answers/participants/${answerId}`,
      "",
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//get competition levels
export const getCompetitionLevels = (competitionId, signal) => {
  console.log(signal);
  return new Promise((resolve, reject) => {
    getMethod(
      `marking/possible_similar_answers/competition_levels/${competitionId}`,
      "",
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getParticipantData = (id) => {
  return new Promise((resolve, reject) => {
    getMethod2(`info/participant/${id}`, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getMarkedParticipants = (id, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(
      `competition/cheaters/custom-labeled-integrity-cases/${id}`,
      "",
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getIntegrityListStats = (id, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/cheaters/criteria-stats/${id}`, "", signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const CountryIntegrityData = (id, countryId, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/cheaters/${id}/${countryId}`, "", signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getMWData = (id, page) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/team-based/simoc/${id}/mw/data`, page)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const listCertificates = (page) => {
  return new Promise((resolve, reject) => {
    getMethod2(`certificates?page=${page}`, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getMMMData = (id, page) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/team-based/simoc/${id}/mmm/data`, page)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const downloadCertificate = (id) => {
  return new Promise((resolve, reject) => {
    getMethod2(`certificates/download/${id}/generate-token`, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Team Competition
export const getTeamCompetitions = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod("competition/team-based/index", params, signal)
      .then((d) => {
        resolve(d);
      })
      .catch((e) => reject(e));
  });
};

//export data

export const exportMMM = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    downloadingfiles(
      `competition/team-based/simoc/${id}/mmm/excel-data`,
      "MMM-Data"
    )
      .then((d) => {
        resolve(d);
      })
      .catch((e) => reject(e));
  });
};

export const exportMW = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    downloadingfiles(
      `competition/team-based/simoc/${id}/mw/excel-data`,
      "MW-Data"
    )
      .then((d) => {
        resolve(d);
      })
      .catch((e) => reject(e));
  });
};

//Get filter for printing certificates
export const getPrintCertificateFilter = (getParam, additionalParams = {}) => {
  return new Promise((resolve, reject) => {
    // Build query string from additional params
    const queryParams = new URLSearchParams();

    // Add additional params to query string
    Object.entries(additionalParams).forEach(([key, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        key !== getParam
      ) {
        queryParams.append(key, value);
      }
    });

    // Add the required get parameter
    queryParams.append("get", getParam);

    // Build the final URL
    const queryString = queryParams.toString();

    const url = `certificates/getFilterOptions${
      queryString ? `?${queryString}` : ""
    }`;

    getMethod2(url, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Team Based Members
export const getTeamBasedMembers = (params, id, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(
      `competition/team-based/simoc/${id}/participants`,
      params,
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};
//Get uploaded participants files
export const getUploadedParticipantsFiles = (page) => {
  return new Promise((resolve, reject) => {
    getMethod2(`imports/participants?page=${page}`, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//Download uploaded participants file
export const downloadParticipantsFile = (id) => {
  return new Promise((resolve, reject) => {
    downloadingfilesCsv(
      `imports/participants/download/${id}`,
      "uploaded-participants-file"
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getCollectionsListing = (signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("collection/list/ids", "", signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//Get imported participants filter options
export const getImportedParticipantsFilterOptions = (
  getParam,
  otherAppliedFilters
) => {
  return new Promise((resolve, reject) => {
    getMethod2(
      `imports/participants/filter-options?get_filter=${getParam}&sort=asc&${otherAppliedFilters}`,
      ""
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//Enhanced Comp Report
export const getEnhancedCompReport = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/report/${id}`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const enhancedGetReport = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    console.log(signal);
    getMethod2(`competition/report/${id}?mode=csv`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//filter for configureD certificate templates
export const filterConfiguredCertificateTemplates = (
  getParam,
  additionalParams = {}
) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams();
    Object.entries(additionalParams).forEach(([key, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        key !== getParam
      ) {
        if (Array.isArray(value)) {
          value.forEach((v) => queryParams.append(key, v));
        } else {
          queryParams.append(key, value);
        }
      }
    });
    queryParams.append("get_filter", getParam);
    const queryString = queryParams.toString();
    const url = `certificates/template/index/filter-options${
      queryString ? `?${queryString}` : ""
    }`;
    getMethod2(url, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//Get filter for configure new competition in print certificates
export const getConfigureNewCompetitionInPrintCertificatesFilter = (
  getParam,
  additionalParams = {}
) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams();
    Object.entries(additionalParams).forEach(([key, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        key !== getParam
      ) {
        if (Array.isArray(value)) {
          value.forEach((v) => queryParams.append(key, v));
        } else {
          queryParams.append(key, value);
        }
      }
    });
    queryParams.append("get_filter", getParam);
    const queryString = queryParams.toString();
    const url = `certificates/template/get/filter-options${
      queryString ? `?${queryString}` : ""
    }`;
    getMethod2(url, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

/** Filter options for edit configuration - uses certificates/template/index/filter-options */
export const getCertificateTemplateIndexFilterOptions = (
  getParam,
  additionalParams = {}
) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams();
    Object.entries(additionalParams).forEach(([key, value]) => {
      if (
        value !== undefined &&
        value !== null &&
        value !== "" &&
        key !== getParam
      ) {
        if (Array.isArray(value)) {
          value.forEach((v) => queryParams.append(key, v));
        } else {
          queryParams.append(key, value);
        }
      }
    });
    queryParams.append("get_filter", getParam);
    const queryString = queryParams.toString();
    const url = `certificates/template/get/filter-options${
      queryString ? `?${queryString}` : ""
    }`;
    getMethod2(url, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//get champions
export const getChampions = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/team-based/simoc/${id}/champions`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const exportChampions = (id, params) => {
  return new Promise((resolve, reject) => {
    downloadingfiles(
      `competition/team-based/simoc/${id}/champions/export${
        params ? `${params}` : ""
      }`,
      "Champions"
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getTeamBasedAwardsCriteria = (id, params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/team-based/${id}/awards`, "", signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getTeamData = (params, id, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/team-based/${id}/participants`, params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getTeamsList = (params, id) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/team-based/${id}/teams/list`, params)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getComputeState = (id, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/team-based/simoc/${id}/compute-status`, "", signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const exportTeamBasedData = (id, signal) => {
  return new Promise((resolve, reject) => {
    downloadingfiles(
      `competition/team-based/${id}/excel-data`,
      "Team-Based-Data"
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getTeamBasedComputeStatus = (id, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`competition/team-based/${id}/compute-status`, "", signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

//Get configured new competitions in print certificates
export const getConfiguredNewCompetitionsInPrintCertificates = (
  params = {}
) => {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, value);
      }
    });
    const queryString = queryParams.toString();
    const url = `certificates/template${queryString ? `?${queryString}` : ""}`;
    getMethod2(url, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Temporarily commented - CORS blocked direct S3 upload
// export const getCertificateTemplatePresignedUrl = (fileName) => {
//   return new Promise((resolve, reject) => {
//     const encodedName = encodeURIComponent(fileName);
//     getMethod2(
//       `certificates/template/get/pre-signed-url?file_name=${encodedName}`,
//       ""
//     )
//       .then((d) => resolve(d))
//       .catch((e) => reject(e));
//   });
// };

export const getCertificateTemplate = (id) => {
  return new Promise((resolve, reject) => {
    getMethod2(`certificates/template/${id}`, "")
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Get a configured certificate template award printed with dummy data (PDF blob)
export const getCertificateTemplateAwardPreview = (awardId) =>
  getBlobMethod(`certificates/template/awards/${awardId}/preview`);

// Get a configured certificate template award file (PDF blob)
export const getCertificateTemplateAwardDownload = (awardId) =>
  getBlobMethod(`certificates/template/awards/${awardId}/download`);

/** Download certificate template file. Use downloadUrl if API provides it, else use path with API endpoint. */
export const downloadCertificateTemplateFile = (
  pathOrDownloadUrl,
  fileName
) => {
  if (
    typeof pathOrDownloadUrl === "string" &&
    (pathOrDownloadUrl.startsWith("http://") ||
      pathOrDownloadUrl.startsWith("https://"))
  ) {
    window.open(pathOrDownloadUrl, "_blank");
    return Promise.resolve();
  }
  return downloadingFileAsIs(
    `certificates/template/file/${encodeURIComponent(pathOrDownloadUrl)}`,
    fileName || "certificate-template"
  );
};

/**
 * Download certificate configuration file as-is (PDF or other format).
 * Preserves original filename/extension. Supports full download URL or API path.
 */
export const downloadCertificateConfigurationFile = (
  pathOrDownloadUrl,
  fileName
) => {
  const fname = fileName || "certificate-template.pdf";
  if (
    typeof pathOrDownloadUrl === "string" &&
    (pathOrDownloadUrl.startsWith("http://") ||
      pathOrDownloadUrl.startsWith("https://"))
  ) {
    return fetch(pathOrDownloadUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fname;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      });
  }
  return downloadingFileAsIs(
    `certificates/template/file/${encodeURIComponent(pathOrDownloadUrl)}`,
    fname
  );
};

export const exportTeamBasedMembers = (id, params) => {
  return new Promise((resolve, reject) => {
    downloadingfiles(
      `competition/team-based/${id}/participants/export${
        params ? `${params}` : ""
      }`,
      "Team-Based-Members"
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getTags = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("tag/filter-options", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getTopics = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("topics/filter-options", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const exportParticipants = (params) => {
  return new Promise((resolve, reject) => {
    downloadingfilesCsv(
      `participant/list/export${params ? `${params}` : ""}`,
      "Participants"
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getPowerBiEmbedToken = (params = "", signal) => {
  return new Promise((resolve, reject) => {
    getMethod("dashboard/powerbi/embed-token", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Translations - Assignments
export const getAssignments = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("translations/assignments", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getAssignment = (id, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(`translations/assignments/${id}`, "", signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getAssignmentStoreFilterOptions = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("translations/assignments/store-filter-options", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

export const getAssignmentIndexFilterOptions = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2("translations/assignments/index-filter-options", params, signal)
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Translations - Contest paper export filter options
// params e.g. `?get_filter=competition`, `?get_filter=options`
export const getContestPaperExportFilterOptions = (params, signal) => {
  return new Promise((resolve, reject) => {
    getMethod2(
      "translations/exports/contest-paper/filter-options",
      params,
      signal
    )
      .then((d) => resolve(d))
      .catch((e) => reject(e));
  });
};

// Translations - Contest paper exports
// Backend endpoint not yet provided: returns mock data so the UI is functional.
export const getContestExports = (_params, _signal) => {
  console.warn(
    "[TODO] GET /translations/exports endpoint not provided by backend yet - returning mock data"
  );
  const mock = {
    data: [
      {
        id: 1,
        competition: "SASMO 2026",
        languages: ["English", "Mandarin"],
        grade: "Grade 3 / Primary 3",
        progress: 100,
        file_url: null,
      },
      {
        id: 2,
        competition: "SASMO 2026",
        languages: ["English"],
        grade: "Grade 5 / Primary 5",
        progress: 65,
        file_url: null,
      },
    ],
    current_page: 1,
    last_page: 1,
    total: 2,
  };
  return Promise.resolve(mock);
};

export const getContestExportProgress = (id) => {
  console.warn(
    `[TODO] GET /translations/exports/${id}/progress endpoint not provided by backend yet - returning mock`
  );
  return Promise.resolve({ id, progress: 100 });
};

export const downloadContestExport = (id, fileName) => {
  console.warn(
    `[TODO] GET /translations/exports/${id}/download endpoint not provided by backend yet`
  );
  return downloadingfiles(
    `translations/exports/${id}/download`,
    fileName || `contest-paper-${id}`
  );
};

export const getExportConfigurations = (_params, _signal) => {
  console.warn(
    "[TODO] GET /translations/exports/configurations endpoint not provided by backend yet - returning mock"
  );
  return Promise.resolve({ data: [] });
};
